<script setup>
  import { ref } from 'vue';
  import axios from 'axios';
  import FormSelect from '~/components/form/FormSelect.vue';

  const countriesList = ref([]);

  async function getCountriesList() {
    try {
      const { data } = await axios.get('/countries');

      const countriesOptions = data.map((country) => ({
        value: country.name,
        label: country.name,
      }));
      countriesList.value = countriesOptions;
    } catch (err) {
      countriesList.value = [];
    }
  }

  getCountriesList();
</script>

<template>
  <FormSelect :options="countriesList" placeholder-text="Select a Country" />
</template>
